import { combineReducers } from 'redux';

import layout from "./layout";

import form from "./form";
import agentDetails from "./agentDetails";
import vehicle from "./vehicle";
import user from "./user";
import employee from "./employee";
import agent from "./agent";
import bit from "./bit";
import hammer from "./hammer";
import pointAddress from "./pointAddress";
import diesel from "./diesel";
import expense from './expense';

import company from "./company";
import companyDetail from './companyDetail';
import Device from "./device";
import configuration from './configuration';

import alertLog from "./alertLog";

export default combineReducers({
    layout,
    form,
    agentDetails,
    vehicle,
    user,
    employee,
    agent,
    bit,
    hammer,
    pointAddress,
    diesel,
    expense,

    company,
    companyDetail,
    Device,
    configuration,

    alertLog
});
